<template>
  <div class='AdmNave'
  v-if="show"
  :style="{ 
    marginLeft: !nivel ? '0px' : '200px',
    marginTop: !nivel ? '0px' : '-43px'
  }"
  >
    <div
    v-for="(link, key) in data"
    :key="key"
    >
      <div class="link"
      @mouseenter="$emit('showChildren', { id: link.id, value: true })"
      @mouseleave="$emit('showChildren', { id: link.id, value: false })"
      @click="to(link.path)"
      >
        <div class="icon">
          <component :is="link.icon"/>
        </div>
        <div class="text">{{ link.text }}</div>
        <div class="arrow"><arrow-icon v-if="link.childrens"/></div>
      </div>
      <adm-nave
      v-if="link.childrens"
      :data="link.childrens"
      :nivel="link.childrens[0].nivel"
      :show="link.childrens[0].visible"
      @mouseenter="$emit('showChildren', { id: link.id, value: true })"
      @mouseleave="$emit('showChildren', { id: link.id, value: false })"
      @showChildren="newValue => $emit('showChildren', newValue)"
      />
    </div>
  </div>
</template>

<script>
import cardIcon from '../icons/cardIcon'
import arrowIcon from '../icons/arrowIcon'
import asignIcon from '../icons/asignIcon'
import businessIcon from '../icons/businessIcon'
import NetIcon from '../icons/NetIcon'
import blockIcon from '../icons/blockIcon'
export default {
  name: 'AdmNave',
  components: { AdmNave: () => import('./AdmNave'), cardIcon, arrowIcon, asignIcon, businessIcon, NetIcon, blockIcon },
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    nivel: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    to (path) {
      if(typeof path !== 'undefined') {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.AdmNave {
  width: 200px;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  background-color: #FFFFFF;
  position: absolute;
}
.link {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  color: #717884;
}
.link:hover {
  background-color: #EEEEEE;
}
.icon {
  width: 30px;
}
.text {
  width: 130px;
  text-align: left;
}
.arrow {
  width: 20px;
  display: flex;
  align-items: center;
}
</style>
